import { useForm } from "react-hook-form";
import React, { useState, useEffect } from 'react';
import axios from 'axios'; 
import { FilePdf } from "@phosphor-icons/react";
import Select from "react-select";
import { useGetCategoriesProductsQuery } from "../apis/CategoriesApi";
import { storage } from "../common/firebaseConfig";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { useCreateShopProfilesMutation, useGetAllShopProfilesByUserIdQuery } from "../apis/ShopProfileApi";
import { getUserData } from "../auth";
import ProfileCard from "./ShopProfile/ProfileCard";
import EditShopForm from "./ShopProfile/EditShopForm";
const ShopProfileView = () => {
 
  const userData = getUserData();
  const userId = userData?.uid || "";
  
  const {
    register, 
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      id: 0,
      shopDescription: "",
      streetAddressShopAddress: "",
      countryShopAddress: "",
      cityShopAddress: "",
      stateShopAddress: "",
      zipShopAddress: "",
      adminCommissionRate: 20,
      shopStatus: "pending",
      coverImageUrl: "",
      imageLogoUrl: "",
      icon: "",
      url: "",
      latLocation: 0,
      lngLocation: 0,
      cityLocation: "",
      stateLocation: "",
      countryLocation: "",
      zipLocation: "",
      formattedAddressLocation: "",
      createdAt: "2024-12-27T09:47:52.857Z",
      updatedAt: "2024-12-27T09:47:52.857Z",
      documents: [],
      imagesUrls: [],
      dateValidateProfile:'',
      categoryProducts: [
        {
          id: 0,
          name: "",
        },
      ],
    },
  });

  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
 
  const [coverImage, setCoverImage] = useState(null);
  const [iconImage, setIconImage] = useState(null);
  const [createShopProfiles, { isLoading:isLoadingCreate, isSuccess, isError:isErrorCreate, error }] =
    useCreateShopProfilesMutation();
    const [isEditMode, setIsEditMode] = useState(false); // State to manage edit mode
  
    // Toggle between edit and view modes
    const toggleEditMode = () => {
      setIsEditMode(!isEditMode);
    };
  
    // Handle form submission
    const handleSubmitEdit = (data) => {
      console.log("Form data submitted:", data);
      setIsEditMode(false); // Exit edit mode after submission
    };
  
 // State for user data
 const { data:profileInfo, error:errorProfileInfo, isLoading:isLoadingProfileInfo } = useGetAllShopProfilesByUserIdQuery(userId, {
  skip: !userId, // Skip the query if userId is not available
});
console.log('profileInfo',profileInfo)
  const [selectedCategories, setSelectedCategories] = useState();
  
  const [documents, setDocuments] = useState([]);
  const [documentPreviews, setDocumentPreviews] = useState([]);
// State for handling geolocation denial
  const [locationError, setLocationError] = useState(null); 
  // Fetch categories data from the API
  const { data: categoriesData, isLoading, isError } = useGetCategoriesProductsQuery();
// Transform the categories data into the format required by react-select
const options = categoriesData
? categoriesData.map((category) => ({
    value: category.id,
    label: category.name,
  }))
: [];
const isFileSizeValid = (base64) => {
  const base64Length = base64.length - (base64.indexOf(",") + 1);
  const padding = base64.endsWith("==") ? 2 : base64.endsWith("=") ? 1 : 0;
  const fileSizeInBytes = (base64Length * 3) / 4 - padding;
  return fileSizeInBytes <= 2 * 1024 * 1024;
};

const base64ToBlob = (base64) => {
  const byteString = atob(base64.split(",")[1]);
  const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  return new Blob([arrayBuffer], { type: mimeString });
};


 // Handle Cover Image Change
 const handleCoverImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      convertToBase64(file).then((base64) => {
        setCoverImage(base64); // Set the Base64 string for cover image
        setValue('coverImageUrl', base64); // Update the form with the first image
  
      });
    }
  };
  
  // Handle Icon Image Change
  const handleIconImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      convertToBase64(file).then((base64) => {
        setIconImage(base64); // Set the Base64 string for icon image
        setValue('imageLogoUrl', base64); // Update the form with the second image
  
      });
    }
  };

  // Helper function to convert file to Base64
const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // Resolve with Base64 string
      reader.onerror = reject; // Reject in case of error
      reader.readAsDataURL(file); // Read the file as a Data URL (Base64)
    });
  };
  
const uploadBase64ImageWithProgress = (base64Image, path, setProgress) => {
  return new Promise((resolve, reject) => {
    const blob = base64ToBlob(base64Image);
    const storageRef = ref(storage, path);
    const uploadTask = uploadBytesResumable(storageRef, blob);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Calculate progress as a percentage
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(progress);
      },
      (error) => {
        // Handle upload errors
        reject(error);
      },
      async () => {
        // Handle successful uploads and get the download URL
        const downloadUrl = await getDownloadURL(uploadTask.snapshot.ref);
        resolve(downloadUrl);
      }
    );
  });
};

const handleImageUpload = async (base64Image, path, setProgress) => {
  if (!isFileSizeValid(base64Image)) {
    throw new Error("File size exceeds 2 MB limit.");
  }
  return await uploadBase64ImageWithProgress(base64Image, path, setProgress);
};

const uploadImages = async (coverImageBase64, logoImageBase64, setProgress, setIsUploading) => {
  try {
    setIsUploading(true); // Disable submit button

    const coverImageUrl = coverImageBase64
      ? await handleImageUpload(coverImageBase64, `BlinkBuyShops/cover-${Date.now()}`, setProgress)
      : "";

    const logoImageUrl = logoImageBase64
      ? await handleImageUpload(logoImageBase64, `BlinkBuyShops/logo-${Date.now()}`, setProgress)
      : "";

    setIsUploading(false); // Enable submit button after upload completes
    return { coverImageUrl, logoImageUrl };
  } catch (error) {
    setIsUploading(false); // Enable submit button if error occurs
    throw new Error("Image upload failed: " + error.message);
  }
};

const uploadImagesArrays = async (documentsBase64 = [], imagesBase64 = [], setProgress, setIsUploading) => {
  try {
    setIsUploading(true); // Disable submit button

    let totalProgress = 0;
    const updateProgress = (progress) => {
      totalProgress += progress / (documentsBase64.length + imagesBase64.length);
      setProgress(totalProgress);
    };

    const documentsUrls = await Promise.all(
      documentsBase64.map((base64, index) =>
        handleImageUpload(base64, `BlinkBuyShopsDocuments/documentsTest-${Date.now()}-${index}`, updateProgress)
      )
    );

    const imagesUrls = await Promise.all(
      imagesBase64.map((base64, index) =>
        handleImageUpload(base64, `BlinkBuyShopsImages/imagesTest-${Date.now()}-${index}`, updateProgress)
      )
    );

    setIsUploading(false); // Enable submit button after upload completes
    return { documentsUrls, imagesUrls };
  } catch (error) {
    setIsUploading(false); // Enable submit button if error occurs
    throw new Error("Image upload failed: " + error.message);
  }
};

const handleChange = (selectedOptions) => {
  setSelectedCategories(selectedOptions || []);
  setValue(
    "categoryProducts",
    selectedOptions.map((option) => ({ id: option.value, name: option.label }))
  ); // Transform options into the required structure
};
  
  // Handle file upload and convert images to base64
 
  async function handleFileUploadImages(event) {
    // Function to check if the file is an image
    function isValidImage(file) {
      const allowedTypes = [
        'image/jpeg',  // JPEG format
        'image/png',   // PNG format
        'image/gif',   // GIF format
        'image/webp',  // WebP format
        'image/bmp',   // BMP format
        'image/tiff',  // TIFF format
        'image/svg+xml' // SVG format
      ];
    
      const maxSize = 2 * 1024 * 1024; // Maximum size: 2MB
  
      if (!allowedTypes.includes(file.type)) {
        alert(`File type not allowed: ${file.name}. Please upload a valid image.`);
        return false;
      }
  
      if (file.size > maxSize) {
        alert(`File size exceeds the limit of 5MB: ${file.name}.`);
        return false;
      }
  
      return true;
    }
  
    // Function to read a file asynchronously
    function readFileAsync(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
  
        reader.onload = () => resolve(reader.result);
        reader.onerror = (event) => reject(event.target.error);
        
        reader.readAsDataURL(file); // Read as Data URL (base64)
      });
    }
  
    const files = Array.from(event.target.files || []);
    const validFiles = files.filter(isValidImage); // Filter files by validation
  
    if (validFiles.length === 0) {
      alert('No valid images selected. Please try again.');
      return;
    }
  
    try {
      const uploadedImages = await Promise.all(validFiles.map((file) => readFileAsync(file)));
  
      // Update the form with valid image URLs
      setValue('imagesUrls', uploadedImages);
  
      // Update local state with previews for valid images
      setDocumentPreviews(uploadedImages);
    } catch (error) {
      console.error("Error during file upload:", error);
      alert("An error occurred while uploading the images. Please try again.");
    }
  }
  async function handleFileUploadPdfs(event) {
    // Function to read the file asynchronously
    function readFileAsync(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
  
        reader.onload = () => resolve(reader.result);
  
        reader.onerror = (event) => {
          console.error("File read error:", event.target.error);
          alert(`Failed to read file: ${file.name}. Please check if the file is accessible and try again.`);
          reject(event.target.error);
        };
  
        try {
          reader.readAsDataURL(file); // Read as Data URL (base64)
        } catch (error) {
          console.error("An unexpected error occurred while reading the file:", error);
          reject(error);
        }
      });
    }
  
    // Function to check file size (limit to 2MB)
    function isValidPdf(file) {
      const maxSize = 2 * 1024 * 1024; // 2MB
  
      if (file.size > maxSize) {
        alert(`File size exceeds the 2MB limit: ${file.name}`);
        return false;
      }
  
      return true;
    }
  
    const files = Array.from(event.target.files || []);
    
    try {
      const uploadedFiles = await Promise.all(
        files.map((file) =>
          isValidPdf(file) ? readFileAsync(file).catch((error) => {
            console.warn(`Skipping file: ${file.name} due to error:`, error);
            return null; // Skip problematic files
          }) : null // Skip file if it exceeds size limit
        )
      );
  
      // Filter out null values (files that failed to read or were too large)
      const validFiles = uploadedFiles.filter((file) => file !== null);
  
      if (validFiles.length === 0) {
        alert("No valid files were uploaded. Please try again with accessible files or files under 2MB.");
        return;
      }
  
      // Update the form and local state with valid files
      setValue('documents', validFiles);
      setDocuments(validFiles);
  
    } catch (error) {
      console.error("Unexpected error during file upload:", error);
      alert("An unexpected error occurred during file upload. Please try again.");
    }
  }
  // Handle image removal
  function removeImage(index) {
    const updatedImages = documentPreviews.filter((_, i) => i !== index);
    setDocumentPreviews(updatedImages);
    setValue('imagesUrls', updatedImages); // Update react-hook-form field after removal
  }
  // Handle image removal
  function removePDf(index) {
    const updatedPdf = documents.filter((_, i) => i !== index);
    setDocuments(updatedPdf);
    setValue('documents', updatedPdf); // Update react-hook-form field after removal
  }
 
  const onSubmit = async (data,event) => {
    event.preventDefault(); // Prevent default form submission

    if (!selectedCategories || selectedCategories.length === 0) {
      alert("Please select at least one category before submitting.");
      return; // Stop form submission
    } 
      const coverImageBase64 = watch("coverImageUrl");
      const logoImageBase64 = watch("imageLogoUrl");

      const watchDocuments = watch("documents");
      const watchImages = watch("imagesUrls");
 
   // Step 1: Upload images and get URLs
    const { coverImageUrl, logoImageUrl } = await uploadImages(
      coverImageBase64,
      logoImageBase64, setProgress, setIsUploading
    );

     // Upload documents and images
     const { documentsUrls, imagesUrls } = await uploadImagesArrays(
      watchDocuments,
      watchImages,   setProgress, setIsUploading
    );
    setValue('coverImageUrl', coverImageUrl);
    setValue('imageLogoUrl', logoImageUrl); 

    setValue('documentsUrls', documentsUrls);
    setValue('imagesUrls', imagesUrls); 

 const updatedData = {
  ...data,
  coverImageUrl, // Directly include the user_id
  imageLogoUrl:logoImageUrl, // Directly include the
  documents:documentsUrls,
  imagesUrls
};
   
 console.log('data2',updatedData);
 try {
       
  // Step 3: Call mutation
   await createShopProfiles({ shopProfile: updatedData, userId }).unwrap();

  console.log('Shop profile created successfully!');
  // Refresh data by searching Current Shop by id user form after success
} catch (err) {
  console.error('Failed to create shop profile:', err);
}

  };
 
// Function to determine progress bar color and completion percentage
const getProgressData = (status) => {
  switch (status) {
    case 'pending':
      return { completed: 33, color: 'warning' };
    case 'verifying':
      return { completed: 66, color: 'info' };
    case 'approved':
      return { completed: 100, color: 'success' };
    case 'blocked':
      return { completed: 100, color: 'danger' }; 
    default:
      return { completed: 0, color: 'secondary' };
  }
};

const { completed, color } = getProgressData(profileInfo?.shopStatus);
  // Render pre-populated data
  
  // Render the view mode
  const renderViewMode = () => (
    <div>
      <h6 className="mb-32">Shop Details </h6>
      <div className="row gy-4">
        
        <div className="col-sm-12">
          <h6>Description</h6>
          <p>{profileInfo.shopDescription}</p>
        </div>

        <div className="col-sm-12">
          <h6>Address</h6>
          <p>
            {profileInfo.streetAddressShopAddress},<br />
            {profileInfo.cityShopAddress}, {profileInfo.stateShopAddress}<br />
            {profileInfo.zipShopAddress}
          </p>
        </div>

        {/* Display existing images */}
        {profileInfo.coverImage && (
          <div className="col-sm-12">
            <h6>Cover Image</h6>
            <img src={profileInfo.coverImage} className="img-fluid rounded-8" style={{ maxHeight: "200px" }} />
          </div>
        )}

        <div className="col-sm-12 mt-32">
          <button className="btn btn-main py-18 px-32 rounded-8" onClick={toggleEditMode}>
            Edit Profile
          </button>
        </div>
      </div>
    </div>
  );

if (isLoadingProfileInfo) {
  return <div>Loading...</div>; // Display loading state while fetching data
}

if (errorProfileInfo) {
  return <div>Error: {errorProfileInfo.message}</div>; // Handle error state
}
// Conditionally render components based on profileInfo
if (profileInfo === null) {
 // Render AddProfile component if profileInfo is null

 return (
  <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
    <form onSubmit={handleSubmit(onSubmit)}>
      <h6 className="mb-32">Edit Shop Details</h6>
      {locationError && <p style={{ color: 'red' }}>{locationError}</p>} 
     <div className="row gy-4">
       
        {/* Shop Category */}
    
        <div className="col-sm-6">
    <h6>Select Categories</h6>
    <div className="p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
      {isLoading && <p>Loading categories...</p>}
      {isError && <p>Error loading categories.</p>}
      {!isLoading && !isError && (
        <Select
          className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
          options={options}
          isMulti
          value={selectedCategories}
          onChange={handleChange}
          placeholder="Select categories..."
          styles={{
            menu: (provided) => ({ ...provided, zIndex: 9999 }), // Prevent dropdown clipping
          }}
        />
      )} 
    </div> 
  </div>


{/* Shop Description */}
<div className="col-sm-12">
<label
  htmlFor="shopDescription"
  className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
>
  Shop Description
</label>
<textarea
  className="common-input px-16"
  id="shopDescription"
  placeholder="Describe your shop"
  {...register("shopDescription", {
    required: "Shop description is required", // Add validation
    maxLength: {
      value: 500,
      message: "Shop description must not exceed 500 characters", // Optional rule
    },
  })}
/>
{errors.shopDescription && (
  <p className="text-red-500 mt-2">{errors.shopDescription.message}</p>
)}
</div>

{/* Address Fields */}
<div className="col-sm-12">
<h6>Shop Address</h6>

{/* Street Address */}
<label
  htmlFor="streetAddressShopAddress"
  className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
>
  Street Address
</label>
<input
  type="text"
  className="common-input px-16"
  id="streetAddressShopAddress"
  placeholder="Street Address"
  {...register("streetAddressShopAddress", {
    required: "Street Address is required",
  })}
/>
{errors.streetAddressShopAddress && (
  <p className="text-red-500 mt-2">{errors.streetAddressShopAddress.message}</p>
)}

{/* City */}
<label
  htmlFor="cityShopAddress"
  className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
>
  City
</label>
<input
  type="text"
  className="common-input px-16"
  id="cityShopAddress"
  placeholder="City"
  {...register("cityShopAddress", {
    required: "City is required",
  })}
/>
{errors.cityShopAddress && (
  <p className="text-red-500 mt-2">{errors.cityShopAddress.message}</p>
)}

{/* State */}
<label
  htmlFor="stateShopAddress"
  className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
>
  State
</label>
<input
  type="text"
  className="common-input px-16"
  id="stateShopAddress"
  placeholder="State"
  {...register("stateShopAddress", {
    required: "State is required",
  })}
/>
{errors.stateShopAddress && (
  <p className="text-red-500 mt-2">{errors.stateShopAddress.message}</p>
)}

{/* ZIP Code */}
<label
  htmlFor="zipShopAddress"
  className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
>
  ZIP Code
</label>
{/* ZIP Code */}
<label
  htmlFor="zipShopAddress"
  className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
>
  ZIP Code
</label>
<input
  type="text"
  className="common-input px-16"
  id="zipShopAddress"
  placeholder="ZIP Code"
  {...register("zipShopAddress", {
    required: "ZIP Code is required",
  })}
/>


{errors.zipShopAddress && (
  <p className="text-red-500 mt-2">{errors.zipShopAddress.message}</p>
)}
</div>
 {/* Cover Image */}
 <div className="col-sm-12">
            <label
              htmlFor="coverImage"
              className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
            >
              Cover Image
            </label>
            <input
              type="file"
              className="common-input px-16"
              id="coverImage"
              accept="image/*"
              onChange={handleCoverImageChange}
            />
            {coverImage && (
              <div className="mt-3">
                <h6>Cover Image Preview</h6>
                <img
                  src={coverImage}
                  alt="Cover Preview"
                  className="img-fluid rounded-8"
                  style={{ maxHeight: "200px", objectFit: "cover" }}
                />
              </div>
            )}
          </div>

          {/* Icon Image */}
          <div className="col-sm-12">
            <label
              htmlFor="iconImage"
              className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
            >
              Icon Image
            </label>
            <input
              type="file"
              className="common-input px-16"
              id="iconImage"
              accept="image/*"
              onChange={handleIconImageChange}
            />
            {iconImage && (
              <div className="mt-3">
                <h6>Icon Image Preview</h6>
                <img
                  src={iconImage}
                  alt="Icon Preview"
                  className="img-fluid rounded-circle"
                  style={{ width: "100px", height: "100px", objectFit: "cover" }}
                />
              </div>
            )}
          </div>
        <div className="col-sm-12">
          
        <label
htmlFor="document"
className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
>
Upload Image identification, passport or Driving licence for verification 
</label>
<div className="mt-4">
        <p>identification updated: {documentPreviews.length}</p>
      </div>
<input
type="file"
className="common-input px-16"
id="Image"
multiple
accept="image/*"
onChange={handleFileUploadImages}

/>


{/* Render Image Previews */}
{documentPreviews.length > 0 && (
<div className="mt-3">
  <h6>Images Identification Preview</h6>
  <div className="row">
    {documentPreviews.map((preview, index) => (
      <div key={index} className="col-sm-4 mb-3 position-relative">
        <img
          src={preview}
          alt={`Preview ${index + 1}`}
          className="img-fluid rounded-8"
          style={{ maxHeight: "150px", objectFit: "cover" }}
        />
        <button
          type="button"
          className="btn btn-main py-6 px-12 rounded-16"
          onClick={() => removeImage(index)}
        >
          X
        </button>
      </div>
    ))}
  </div>
</div>
)}
   
        <label
htmlFor="document"
className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
>
Upload Document(s) (PDF format)
</label>
       <div className="mt-4">
        <p>File updated: {documents.length}</p>
      </div>
<input
type="file"
className="common-input px-16"
id="document"
multiple
accept="application/pdf"
onChange={handleFileUploadPdfs}
/>
{/* Render PDFs */}
{documents.length > 0 && (
<div className="mt-3">
  <h6>File Preview</h6>
  <div className="row">
    {documents.map((_preview, index) => (
      <div key={index} className="col-sm-4 mb-3 position-relative">
        <div style={{ width: '100px', height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
          <FilePdf
            size={50} // Set the size of the PDF icon
            color="red" // You can change the color as needed
            title={`PDF Preview ${index + 1}`}
          
            />
              </div>
        <button
          type="button"
          className="btn btn-main py-6 px-12 rounded-16"
          onClick={() => removePDf(index)}
        >
          X
        </button>
      </div>
    ))}
  </div>
</div>
)}

   </div>

   <div className="col-sm-12 mt-32">
    <button
      type="submit"
      className="btn btn-main py-18 px-32 rounded-8"
      disabled={isLoadingCreate || isUploading} // Disable button while either uploading or loading
      onClick={handleSubmit}
    >
      {isUploading ? `Uploading... ${progress}%` : isLoadingCreate ? 'Submitting...' : 'Request Activation'}
    </button>

    {/* Show progress bar for image upload */}
    {isUploading && (
      <div className="mt-4">
        <progress value={progress} max="100" className="w-full"></progress>
      </div>
    )}

    {/* Show success message */}
    {isSuccess && <p className="text-green-500 mt-4">Shop profile created successfully!</p>}

    {/* Show error message */}
    {isErrorCreate && <p className="text-red-500 mt-4">Error: {error?.message || 'Failed to create.'}</p>}
  </div>
      </div>
    </form>
  </div>
);

} else { 

    return (
      <>
        <div className="container mt-5">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Profile Status Tracker</h5>
              <div className="progress">
                <div
                  className={`progress-bar bg-${color}`}
                  role="progressbar"
                  style={{ width: `${completed}%` }}
                  aria-valuenow={completed}
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  {`${completed}% - ${profileInfo.shopStatus.charAt(0).toUpperCase() + profileInfo.shopStatus.slice(1)}`}
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div className="container mt-5">
        {/* Profile Header */}
        <ProfileCard
        profileInfo={profileInfo}
        isEditMode={isEditMode}
        toggleEditMode={toggleEditMode}
        setValue={setValue}
      />
    </div>

  
          {/* Shop Information Section */}
          <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
          {isEditMode ? (
  <EditShopForm
    profileInfo={profileInfo} 
  />
) : (
  renderViewMode()
)}

         </div>
      </>
    ); 
  
}

};

export default ShopProfileView;

